import { fetchPublicApi } from '@/lib/api/apiServiceBase.ts';
import { BookingPublicSummaryDto } from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';

const bookingSummaryApi = {
  getBookingSummary: (orgSlug: string, token: string) =>
    fetchPublicApi<BookingPublicSummaryDto>(
      'GET',
      `public/organizers/${orgSlug}/booking-summary?token=${token}`,
    ),
  acceptConsent: (orgSlug: string, tourConsentId: string, token: string) =>
    fetchPublicApi<BookingPublicSummaryDto>(
      'POST',
      `public/organizers/${orgSlug}/booking-summary/consents/${tourConsentId}/accept?token=${token}`,
    ),
  getConsentFileUrl: (
    orgSlug: string,
    acceptedConsentId: string,
    token: string,
  ): string =>
    `${import.meta.env.VITE_CAMPDESK_API_URL}public/organizers/${orgSlug}/booking-summary/consents/${acceptedConsentId}/file?token=${token}`,
};

export default bookingSummaryApi;
